import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Link } from 'react-router-dom';
import ActionButton from "../../../common/button/actionbutton.component.jsx";
import ConfirmButton from "../../../common/button/confirmbutton.component.jsx";
import Icon from "../../../common/icon/icon.component.jsx";
import Integrations from "../../../integration/Integrations.jsx";
import CreditMemoModalLink from '../../../invoice/creditmemomodallink.component';
import CreditMemoTypeIcon from "../../../invoice/creditmemotypeicon.component.jsx";
import PaymentTypeIcon from "../../../invoice/paymenttypeicon.component.jsx";
import PaymentLink from "../../../payment/components/PaymentLink";
import PaymentExternalDetails from "../../../payment/externaldetails.component.jsx";
import PaymentTypeLabel from "../../../payment/label.component.jsx";
import PaymentSource from "../../../payment/source.component.jsx";
import { Guard, Permissions } from "../../../role/Guard.jsx";
import { PAYMENT_STATUS } from '../../../state/helpers/Payment';
import PaymentTransaction from "../../../state/payment/PaymentTransaction";
import EventInfoBlock from "./Utils/EventInfoBlock";
import { DetachPaymentButtonMessage, DetachPaymentModalMessage } from "./Utils/VoidPendingPaymentInfo";
import ShopifyExternalCheckoutPaymentAttemptEvent from './shopify-external-checkout-payment-attempt.component';

//can be used by any object supporting deposits
class QuotePaymentReceivedEvent extends Component {

    constructor(props, context) {
        super(props, context)

        const creditMemo = (this.props.object && this.props.object.attributes.creditMemo) ?
            this.props.object.attributes.creditMemo : null
        const contactId = (this.props.object && this.props.object.attributes.creditMemo) ?
            this.props.object.attributes.creditMemo.attributes.contactId : ''

        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            onUpdate: this.props.onUpdate || function () {
            },
            //deposit from successful transaction
            creditMemo: creditMemo,
            //creditMemo used to pay the transaction
            creditMemoUsedAsPayment: null,
            modal: '',
            isDeleted: this.props.object ? this.props.object.attributes.deleted : false,
            className: this.props.className || '',
            transferredToObject: null,
            depositPayableObject: this.props.depositPayableObject,
            contactId: contactId
        }
        this.deletePayment = this.deletePayment.bind(this)
        this.exportIntegration = this.exportIntegration.bind(this)
    }

    componentDidMount() {
        if (this.state.object && this.state.object.attributes.status === 'transferred' && this.getTransferredToObjectId() !== '') {
            AppContext.getApiClient().get(`/${this.state.depositPayableObject.type}/` + this.getTransferredToObjectId()).then(res => {
                if (!res.error) {
                    this.setState({
                        transferredToObject: res,
                    })
                }
            })
        }
        if (this.state.object && this.state.object.attributes.payment.attributes.creditMemoId !== '') {
            AppContext.getApiClient().get(`/credit-memos/` + this.state.object.attributes.payment.attributes.creditMemoId).then(res => {
                if (!res.error) {
                    this.setState({
                        creditMemoUsedAsPayment: res,
                    })
                }
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            proposal: nextProps.proposal || null,
            onUpdate: nextProps.onUpdate || function () { },
            isDeleted: nextProps.object ? nextProps.object.attributes.deleted : false,
            depositPayableObject: nextProps.depositPayableObject || null,
        })
    }

    getTransferredToObjectId() {
        if (this.state.depositPayableObject) {
            switch (this.state.depositPayableObject.type) {
                case 'quotes': return this.state.object.attributes.transferredToQuoteId
                case 'orders': return this.state.object.attributes.transferredToOrderId
            }
        }
        return ''
    }

    deletePayment(event) {
        event.preventDefault()
        AppContext.getApiClient().delete(`/${this.state.depositPayableObject.type}/${this.state.depositPayableObject.id}/payment-transactions/${this.state.object.id}`).then(res => {
            this.state.onUpdate()
        })
    }

    exportIntegration(event) {
        event.preventDefault()
        const exportIdFieldName = this.getExportIDFieldNameByObjectType()
        return AppContext.getApiClient().post(`/staff/${this.state.depositPayableObject.type}/payment-transactions/export`, {
            [exportIdFieldName]: this.state.depositPayableObject.id,
            paymentTransactionId: this.state.object.id,
        }).then(q => {
            setTimeout(() => {
                this.state.onUpdate()
            }, 4000)
        })
    }

    getExportIDFieldNameByObjectType() {
        if (this.state.depositPayableObject) {
            switch (this.state.depositPayableObject.type) {
                case 'quotes': return 'quoteId'
                case 'orders': return 'orderId'
            }
        }
        return ''
    }

    getPaymentTypeIcon(payment) {
        payment = payment || this.state.object.attributes.payment

        return payment.attributes.paymentType ?
            payment.attributes.paymentType.attributes.icon : ''
    }

    renderDeclinedMessage() {
        if (this.state.isDeleted) {
            return [<FormattedMessage
                id="common.analytics.events.payment_detached.text"
                defaultMessage="This {paymentType} of {amount} has been detached"
                values={{
                    paymentType: <strong><PaymentTypeLabel value={this.state.object.attributes.payment.attributes.type} /></strong>,
                    amount: <strong className="text-danger">
                        <FormattedNumber
                            value={this.state.object.attributes.amount}
                            style={'currency'}
                            currency={this.state.object.attributes.currency}
                        />
                    </strong>,
                }}
            />,
            AppContext.getUserLoggedIn().attributes.superUser ? <span className="ml-2">{`(PaymentID: ${this.state.object.attributes.paymentId})`}</span> : '']
        } else if (this.state.object.attributes.status === 'declined') {
            return <FormattedMessage
                id="common.analytics.events.payment_declined.text"
                defaultMessage="A payment has been declined for an amount of {amount} while trying to pay {identifier}"
                values={{
                    identifier: <strong>{this.state.depositPayableObject.attributes.identifier}</strong>,
                    amount: <strong>
                        <FormattedNumber
                            value={this.state.object.attributes.amount}
                            style={'currency'}
                            currency={this.state.object.attributes.currency}
                        />
                    </strong>,
                }}
            />
        }
        return ''
    }

    displayHeadMessage() {
        let paymentType = this.state.object.attributes.payment.attributes.type
        if (paymentType === 'external-checkout' && this.state.object.attributes.payment.attributes.integratedPayment) {
            paymentType = this.state.object.attributes.payment.attributes.integratedPayment.attributes.type
        }

        return this.renderDeclinedMessage() || <FormattedMessage
            id="quote.analytics.events.payment_received.text"
            defaultMessage="{identifier} received a {paymentType} of {amount}"
            values={
                {
                    identifier: <strong>{this.state.depositPayableObject.attributes.identifier}</strong>,
                    paymentType: <strong><PaymentTypeLabel value={paymentType} /></strong>,
                    amount: <strong>
                        <FormattedNumber
                            value={this.state.object.attributes.amount}
                            style={'currency'}
                            currency={this.state.object.attributes.currency}
                        />
                    </strong>,
                }
            }
        />
    }

    displayPaymentType() {
        const isDeclined = this.state.object.attributes.status === 'declined'

        return <div className={'mr-5 align-self-center'}>
            {
                this.state.creditMemoUsedAsPayment &&
                <div className={'w-100 mb-1'}>
                    <label className="col-form-label custom-form-label">
                        < CreditMemoModalLink
                            creditMemoId={this.state.creditMemoUsedAsPayment.id}
                            creditMemoIdentifier={this.state.creditMemoUsedAsPayment.attributes.identifier}
                            contactId={this.state.contactId} />
                    </label>
                </div>
            }
            <h2 className={"m-0 d-flex justify-content-center"}>
                {
                    !this.state.creditMemoUsedAsPayment &&
                    <PaymentTypeIcon className={(isDeclined || this.state.isDeleted) ? 'text-danger' : ''}
                        value={this.state.object.attributes.payment.attributes.type}
                        icon={this.getPaymentTypeIcon()} />
                }
                {
                    this.state.creditMemoUsedAsPayment &&
                    <CreditMemoTypeIcon
                        value={this.state.creditMemoUsedAsPayment.attributes.type}
                        className={'mr-1 pb-0 ' + (this.state.isDeleted ? 'text-danger' : '')} />
                }
            </h2>
        </div>
    }

    displayPaymentAmount(payment) {
        payment = payment || this.state.object.attributes.payment

        return <div className={'mr-5'}>
            <div className={'w-100'}>
                <label className="col-form-label custom-form-label">
                    <strong>
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.payment_amount_spent"
                            defaultMessage="Payment amount"
                        />
                    </strong>
                </label>
            </div>
            <h4 className={"m-0 " + (this.state.isDeleted ? 'text-danger' : '')}>
                <FormattedNumber
                    value={payment.attributes.amount}
                    style={'currency'}
                    currency={payment.attributes.currency}
                />
            </h4>
        </div>
    }

    displayPaymentNote() {
        const isDeclined = this.state.object.attributes.status === 'declined'

        return this.state.object.attributes.payment.attributes.note ? <div className={'mr-5'}>
            <div className={'w-100'}>
                <label className="col-form-label custom-form-label">
                    <strong>
                        {isDeclined ? <FormattedMessage
                            id="common.analytics.events.payment_received.error_label"
                            defaultMessage="Error"
                        /> : <FormattedMessage
                            id="invoice.analytics.events.payment_received.note_label"
                            defaultMessage="Note"
                        />}
                    </strong>
                </label>
            </div>
            <pre>
                {this.state.object.attributes.payment.attributes.note}
            </pre>
        </div> : ''
    }

    displayPaymentSource() {
        return this.state.object.attributes.payment.attributes.source ? <div className={'mr-5'}>
            <div className={'w-100'}>
                <label className="col-form-label custom-form-label">
                    <strong>
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.source_label"
                            defaultMessage="Source"
                        />
                    </strong>
                </label>
            </div>
            <p className={'mb-0'}>
                <PaymentSource value={this.state.object.attributes.payment.attributes.source} />
            </p>
        </div> : ''
    }

    displayOriginalCreditMemoPaymentMethod() {
        if (!this.state.creditMemoUsedAsPayment) {
            return <></>
        }

        const creditMemoOriginalPayment = this.state.creditMemoUsedAsPayment.attributes.payment
        if (!creditMemoOriginalPayment) {
            return <></>
        }
        if (creditMemoOriginalPayment.attributes.type === 'credit') {
            return <></>
        }

        return (
            <div className={'mr-5'}>
                <div className={'w-100'}>
                    <label className="col-form-label custom-form-label">
                        <strong>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received.original_credit_memo_payment_method_label"
                                defaultMessage="Original Payment Method"
                            />
                        </strong>
                    </label>
                </div>
                <p className={'mb-0'}>
                    <PaymentTypeIcon
                        className="mr-1"
                        value={creditMemoOriginalPayment.attributes.type}
                        icon={this.getPaymentTypeIcon(creditMemoOriginalPayment)}
                    />
                    <PaymentTypeLabel standalone={true} nameOnly={true} value={creditMemoOriginalPayment.attributes.type} />
                </p>
            </div>
        )
    }

    getDocumentID() {
        return this.props.quote?.attributes.identifier || this.props.order?.attributes.identifier
    }

    displayDeletePaymentTransactionOption() {
        const paymentTransaction = new PaymentTransaction(this.state.object)
        if (!paymentTransaction.canBeDetachedOrVoided()) {
            return <></>
        }

        return !this.state.isDeleted && !['refunded', 'declined'].includes(this.state.object.attributes.status) &&
            Guard.isAuthorized(Permissions.DeletePayment) && !this.state.transferredToObject ? <div className={'ml-auto align-self-end'}>
            <p className={'mb-1 mt-2'}>
                <ConfirmButton
                    className={'btn btn-sm btn-outline-danger'}
                    onClick={this.deletePayment}
                    message={<DetachPaymentModalMessage
                        paymentTransaction={paymentTransaction}
                        documentID={this.getDocumentID()}
                    />}
                >
                    {<DetachPaymentButtonMessage
                        paymentTransaction={paymentTransaction} />}
                </ConfirmButton>
            </p>
        </div> : ''
    }

    displayPaymentLink() {
        const pay = this.state.object?.attributes.payment
        if (!pay) {
            return ""
        }

        return <EventInfoBlock
            label={<FormattedMessage
                id="common.payment_id.label"
                defaultMessage="Payment ID"
            />}
            info={<PaymentLink
                paymentId={pay.id}
                label={pay.attributes.identifier}
            />}
        />
    }

    displayPaymentInformation() {
        return <div className={'col-12 d-flex align-items-start flex-wrap'}>
            {
                this.displayPaymentType()
            }
            {
                this.displayPaymentLink()
            }
            {
                this.displayPaymentAmount()
            }
            {
                this.displayPaymentNote()
            }
            {
                this.displayPaymentSource()
            }
            {
                this.displayOriginalCreditMemoPaymentMethod()
            }
            {
                this.displayDeletePaymentTransactionOption()
            }
        </div>
    }

    displaySuperUserExportButton() {
        const externalLinks = this.state.object.attributes.externalLinks.filter(link => !["stripe", "paysafe"].includes(link.attributes.integrationKey))
        return AppContext.getUserLoggedIn().attributes.superUser && externalLinks.length === 0 ? <div className={'col-12 border-top pt-2 mt-2'}>
            <div className={'w-100'}>
                <p className={'mb-2'}>
                    <ActionButton className={"btn btn-sm btn-outline-primary"} onClick={this.exportIntegration}>
                        <Icon value={"cloud-upload-alt"} className={"mr-1"} />
                        <FormattedMessage
                            id="payment_transaction.analytics.integration_export_btn"
                            defaultMessage="Export"
                        />
                    </ActionButton>
                </p>
            </div>
        </div> : null
    }

    displayExternalLinks() {
        const externalLinks = this.state.object.attributes.externalLinks.filter(link => !["stripe", "paysafe"].includes(link.attributes.integrationKey))

        return [
            externalLinks.map(link => {
                let url = Integrations.getPaymentTransactionExternalUrl(link)

                return <div className={'col-12 border-top pt-2 mt-2 mb-3'} key={link.id}>
                    <div className={'w-100'}>
                        <p className={'mb-2'}>
                            {Integrations.getPaymentExportedFormattedMessage(link)}
                        </p>
                    </div>
                    <div className={'w-100 d-flex align-items-start flex-wrap'}>
                        <div className={'mr-3'}>
                            <a href={url} target="_blank">
                                {Integrations.getPaymentExportedLogoImg(link)}
                            </a>
                        </div>
                        <div className={'align-self-center'}>
                            <p className={'mb-0'}>
                                <a href={url} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                                    {Integrations.getPaymentExportedCtaFormattedMessage(link)}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            }),
            this.state.object.attributes.payment.attributes.externalLink ?
                <div className={'col-12 border-top pt-2 mt-2'} >
                    <div className={'w-100'}>
                        <p className={'mb-2'}>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received_exported.integration"
                                defaultMessage="This payment was made with {integrationName}"
                                values={{
                                    integrationName: Integrations.getIntegrationNameFromKey(this.state.object.attributes.payment.attributes.externalLink.attributes.integrationKey)
                                }}
                            />
                        </p>
                    </div>
                    <PaymentExternalDetails value={this.state.object.attributes.payment} />
                </div> : '',
        ]
    }

    displayDepositInformation() {
        return this.state.creditMemo &&
            <div className={'col-12 d-flex align-items-start flex-wrap border-top pt-2 mt-2 '}>
                <div className={'w-100'}>
                    <p className={'mb-2'}>
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.credit_memo_details.text"
                            defaultMessage="This deposit has been converted into credit memo {identifier}"
                            values={{
                                identifier: < CreditMemoModalLink
                                    creditMemoId={this.state.creditMemo.id}
                                    creditMemoIdentifier={this.state.creditMemo.attributes.identifier}
                                    contactId={this.state.contactId} />,
                            }} />
                    </p>
                </div>
                {
                    this.state.creditMemo.attributes.deletedBy ? <div className={'w-100'}>
                        <p className={'mb-2 text-danger'}>
                            <Icon className={'mr-1 text-danger'} value={'exclamation'} />
                            <FormattedMessage
                                id="invoice.analytics.events.deposit_deleted_warning.text"
                                defaultMessage="This deposit has been deleted." />
                        </p>
                    </div> : ''
                }
                {
                    this.state.isDeleted &&
                    <div className={'w-100'}>
                        <p className={'mb-2'}>
                            <Icon className={'mr-1 text-warning'} value={'info'} />
                            <FormattedMessage
                                id="invoice.analytics.events.payment_deleted.deposit_exists_warning.text"
                                defaultMessage="If you haven't used the deposit yet, you may delete it from the credit memo listing of this contact" />
                        </p>
                    </div>
                }
                <div className={'mr-5 align-self-center mt-2'}>
                    <h2 className={"m-0"}>
                        <CreditMemoTypeIcon
                            value={this.state.creditMemo.attributes.type}
                            className={'mr-1'} />
                    </h2>
                </div>
                <div className={'mr-5'}>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>
                                <FormattedMessage
                                    id="invoice.analytics.events.payment_received.credit_memo_amount"
                                    defaultMessage="Credit memo amount"
                                />
                            </strong>
                        </label>
                    </div>
                    <h4 className={"m-0"}>
                        <FormattedNumber
                            value={this.state.creditMemo.attributes.amount}
                            style={'currency'}
                            currency={this.state.creditMemo.attributes.currency}
                        />
                    </h4>
                </div>
                {
                    parseFloat(this.state.creditMemo.attributes.remainingAmount) > 0 &&
                    <div className={'mr-5'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label">
                                <strong>
                                    <FormattedMessage
                                        id="invoice.analytics.events.payment_received.credit_memo_remaining_amount"
                                        defaultMessage="Remaining amount"
                                    />
                                </strong>
                            </label>
                        </div>
                        <h4 className={"m-0"}>
                            <FormattedNumber
                                value={this.state.creditMemo.attributes.remainingAmount}
                                style={'currency'}
                                currency={this.state.creditMemo.attributes.currency}
                            />
                        </h4>
                    </div>
                }
                {
                    parseFloat(this.state.creditMemo.attributes.refundedAmount) > 0 &&
                    <div className={'mr-5'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label">
                                <strong>
                                    <FormattedMessage
                                        id="invoice.analytics.events.payment_received.credit_memo_refunded_amount"
                                        defaultMessage="Refunded amount"
                                    />
                                </strong>
                            </label>
                        </div>
                        <h4 className={"m-0"}>
                            <FormattedNumber
                                value={this.state.creditMemo.attributes.refundedAmount}
                                style={'currency'}
                                currency={this.state.creditMemo.attributes.currency}
                            />
                        </h4>
                    </div>
                }
                {
                    this.state.creditMemo.attributes.notes ? <div className={'mr-5'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label">
                                <strong>
                                    <FormattedMessage
                                        id="invoice.analytics.events.payment_received.credit_memo_note_label"
                                        defaultMessage="Note"
                                    />
                                </strong>
                            </label>
                        </div>
                        <pre>
                            {this.state.creditMemo.attributes.notes}
                        </pre>
                    </div> : ''
                }
            </div>
    }

    displayTransferredToObjectInformation() {
        return this.state.transferredToObject &&
            <div className={'col-12 d-flex align-items-start flex-wrap border-top pt-2 mt-2'}>
                <div className={'w-100'}>
                    <p className={'mt-2 mb-0 text-danger'}>
                        <Icon className={'mr-1'} value={'exclamation'} />
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.credit_memo_transferred.text"
                            defaultMessage="This deposit has been transferred to {identifier}. The deposit received amount has been updated to reflect this change on the current document."
                            values={{
                                identifier: <Link to={`/${this.state.depositPayableObject.type}/` + this.state.transferredToObject.id + '/edit'}>
                                    {this.state.transferredToObject.attributes.identifier}
                                </Link>,
                            }} />
                    </p>
                </div>
            </div>
    }

    isPendingOrExpiredExternalShopifyCheckout() {
        if (!this.state.object) {
            return false
        }

        const payment = this.state.object.attributes.payment
        if (!payment) {
            return false
        }

        const integratedPayment = payment.attributes.integratedPayment
        if (!integratedPayment) {
            return false
        }

        return [PAYMENT_STATUS.PENDING, PAYMENT_STATUS.EXPIRED].includes(integratedPayment.attributes.status) &&
            integratedPayment.attributes.paymentFlowType === 'external-checkout' &&
            integratedPayment.attributes.integrationKey.includes('shopify')
    }

    render() {

        if (this.isPendingOrExpiredExternalShopifyCheckout()) {
            return <ShopifyExternalCheckoutPaymentAttemptEvent
                paymentTransaction={this.state.object}
                payableEntity={this.state.depositPayableObject}
                paymentInformation={this.displayPaymentInformation()}
            />
        }

        return <div className={"row " + this.state.className + ((this.state.creditMemo && this.state.creditMemo.attributes.deletedBy) ? ' bg-light' : '')}>
            {this.state.modal}
            <div className="col-12">
                <p className={'mb-1'}>
                    {
                        this.displayHeadMessage()
                    }
                </p>
            </div>
            {
                this.displayPaymentInformation()
            }

            {
                this.displaySuperUserExportButton()
            }

            {
                this.displayExternalLinks()
            }

            {
                this.displayDepositInformation()
            }

            {
                this.displayTransferredToObjectInformation()
            }
        </div>
    }

}

export default QuotePaymentReceivedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-payment-received.component.jsx